<template>
<div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <MentorSidebarMenu :show_menu="true" :show_back_button="false" />
      <div class="content-wrapper" style="padding-left: 165px;">
        <div class="container-wrapper center">
          <div class="row">
            <div class="col-12 p-0 pl-2 pr-5">
              <div class="col-9 pl-2 float-left">
                <h3 class="heading text-uppercase mb-3">{{ accountName }}</h3>
              </div>
              
              <button v-if="aiSummaryFlag == 1" type="button" class="mm-ask-trigger" @click="openAskModal()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-compass h-3.5 w-3.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/AskPanel.tsx:335:14" data-component-name="Icon" style="color: rgb(0, 172, 238);"><path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"></path><circle cx="12" cy="12" r="10"></circle></svg>
                <span class="mm-ask-trigger-label">Ask</span>
              </button>
            </div>
            <div style="clear: both;"></div>
            <div class="col-12 pr-5" v-if="aiSummaryFlag == 1">
              <PlatformSummary
              :role="role"
              ref="PlatformSummary"
              @action="onSummaryAction"
              />
            </div>
            <div class="col-7 pr-3 pr-xl-5">


              <div class="row justify-content-between custom-pl-15 pb-4" v-if="menteeCountLoading == true">
                <div class="col pl-0 pr-2" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
                <div class="col pl-4" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
                <div class="col pl-4 pr-1" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
              </div>

              <div class="row justify-content-between custom-pl-15" v-if="menteeCountLoading == false">
                <div class="col pl-0 pr-xl-4 pr-lg-2">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Mentees</div>
                    <div class="h3">{{ menteeCount }}</div>

                    <span v-if="(ticker == 'Up')" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      {{ tickerText }}</span>
                    <span v-else-if="(ticker == 'Down')" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      {{ tickerText }}</span>
                    <span v-else-if="(ticker == '' && tickerText != '')" class="small px-2 py-1 ">
                      {{ tickerText }}</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>
                    
                  </div>                  
                </div>
                <div class="col px-xl-4 px-lg-2" style="cursor: pointer;" @click="openAccountRepToReviewModal()">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Reps to Review</div>
                    <div class="h3">{{ repsReviewCount }}</div>

                    <span v-if="(previousWeekRepCount < currentWeekRepCount)" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      Up {{ parseInt(currentWeekRepCount - previousWeekRepCount)}} this week</span>
                    <span v-else-if="(previousWeekRepCount > currentWeekRepCount)" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      Down {{ parseInt(previousWeekRepCount - currentWeekRepCount)}} this week</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>

                  </div>                  
                </div>
                <div class="col pl-xl-4 pl-lg-2 pr-0" style="cursor: pointer;" @click="competencyReport()">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Competencies</div>
                    <div class="h3">{{ currentWeekCompetencyCount }}</div>

                    <span v-if="(previousWeekCompetencyCount < currentWeekCompetencyCount)" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      Up {{ parseInt(currentWeekCompetencyCount - previousWeekCompetencyCount)}} this week</span>
                    <span v-else-if="(previousWeekCompetencyCount > currentWeekCompetencyCount)" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      Down {{ parseInt(previousWeekCompetencyCount - currentWeekCompetencyCount)}} this week</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>

                  </div>                  
                </div>
              </div>

              <DashboardMenteesList 
                @openRepToReviewModal="openRepToReviewModal"
                ref="DashboardMenteesList"
              ></DashboardMenteesList>

            </div>
            <div class="col-5 pl-4 pl-xl-4 pr-3 pr-xl-5">              
              <div v-if="(checklistLoading == false && checklistCompleteFlag == 0)">
              <MentorChecklist
                ref="MentorChecklist"
                
              ></MentorChecklist>
              </div>
            <div class="col-12 mb-3 p-0" >
              <div class="shadow rounded px-2 py-1">
                <div class="h4 mt-1 mb-1">Reports</div>

                <div class="row justify-content-center mb-3">

                  <router-link :to="{ name: 'pathwayprogressreports' }" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted" style="border-color: #002F42 !important">
                      <img class="" src="@/assets/manager/Mentor Mentee Progress Report Icon.png" style="width: 25px; margin-top: 5px; margin-bottom: 5px;" />
                      <p class="mb-0 small" style="color: #002F42;">Progress</p>
                  </div>
                  </router-link>

                  <router-link :to="{ name: 'competencyreport' }" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted" style="border-color: #002F42 !important">
                      <img class="" src="@/assets/manager/competency_report_icon.png" style="width: 19px; margin-top: 5px; margin-bottom: 5px;" />
                      <p class="mb-0 small"  style="color: #002F42;">Competency</p>
                  </div>
                  </router-link>

                  <router-link :to="{ name: 'mentorUsageReports' }" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted" style="border-color: #002F42 !important; margin-right: 0px !important;">
                      <img class="" src="@/assets/manager/usage_report_icon.png" style="width: 25px; margin-top: 5px; margin-bottom: 8px;" />
                      <p class="mb-0 small"  style="color: #002F42;">Usage</p>

                  </div>
                  </router-link>

                  <router-link :to="{ name: 'repaudittrail' }" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted" style="border-color: #002F42 !important;">
                      <img class="" src="@/assets/manager/tasks_icon_rep_audit_trail.png" style="width: 22px; margin-top: 5px; margin-bottom: 10px;" />
                      <p class="mb-0 small"  style="color: #002F42;">Tasks</p>
                  </div>
                  </router-link>


                </div>
              </div>
            </div>

            <div class="col-12 p-0" style="padding-top: 22px !important;">
              <DashboardNotifications></DashboardNotifications>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <MenteeRepsToReview 
      :isReptoReviewModalVisible="isReptoReviewModalVisible" 
      @close="closeRepToReviewModal"
      @closeRepToReviewModal="closeRepToReviewModal"
      @reduceRepCount="reduceRepCount"
      ref="MenteeRepsToReview">
    </MenteeRepsToReview>

    <!-- Bell icon to see the introduction slide -->
    <div class="fixed-bell-icon btn btn-primary" @click="showIntroductionSlide" v-if="showSlideNumbers == true">
       <i class="fa fa-bell" aria-hidden="true"></i>       
    </div>


    <IntroductionModal
      :isIntroductionModalVisible="isIntroductionModalVisible"
      :introductionSlideObj="introduction_slide_obj"
      :showSlideNumbers="showSlideNumbers"
      ref="introduction_modal"
      @goToAssessmentLanding="goToAssessmentLanding"
      @close="isIntroductionModalVisible = false"
    ></IntroductionModal>

    <MenteeAssessmentLandingPage 
      :isModalVisible="isAssessmentLandingVisible"
      @closeAssessmentLandingModal="closeAssessmentLandingModal"
      @openAssessmentQuestionModal="openAssessmentQuestionModal"
      ref="MenteeAssessmentLandingModal">
    </MenteeAssessmentLandingPage>

    <MenteeAssessmentQuestionPage 
      :isModalVisible="isAssessmentQuestionVisible"
      @closeAssessmentQuestionModal="closeAssessmentQuestionModal"
      ref="MenteeAssessmentQuestionModal">
    </MenteeAssessmentQuestionPage>
    
    <AccountRepsToReview 
      :isReptoReviewModalVisible="isAccountReptoReviewModalVisible" 
      @close="closeAccountRepToReviewModal"
      @closeAccountRepToReviewModal="closeAccountRepToReviewModal"
      ref="AccountRepsToReview">
    </AccountRepsToReview>

    <EndUserLicenseAgreementModal
      :isModalVisible="isEndUserLicenseAgreementModalVisible" 
      @close="closeEndUserLicenseModal"
      ref="end_user_license_agreement"               
       />

    <AskPanel  
      :role="role" 
      :isModalVisible="isAskModalVisible"
      :menteeNames="menteeNames"
      ref="AskPanel"
      @close="closeAskModal"
      @action="onAskAction"
       />

</div>
</template>

<script>
import axios from 'axios'
// import { store } from '../../store/store';
import router from '../../router/index.js';
import UserMenu from '../shared/user_menu.vue';
import IntroductionModal from '../manager/introductionManagerTemplateModal.vue';
import MentorSidebarMenu from '@/components/shared/mentor_sidebar_menu.vue';
import DashboardMenteesList from '@/components/mentor/dashboard_mentees_list.vue';
import DashboardNotifications from '@/components/manager/dashboard_notifications.vue';
import MenteeRepsToReview from '@/components/manager/mentee_reps_to_review.vue';
import AccountRepsToReview from '@/components/manager/account_reps_to_review.vue';
import MenteeAssessmentLandingPage from '@/components/mentee/mentee_assessment_landing_new.vue';
import MenteeAssessmentQuestionPage from '@/components/mentee/mentee_assessment_question_new.vue';
import MentorChecklist from '@/components/mentor/checklist.vue';
import EndUserLicenseAgreementModal from '@/components/shared/end_user_license_agreement_modal.vue';
import AskPanel from '@/components/manager/ask_panel_modal.vue';
import PlatformSummary from '@/components/manager/PlatformSummary.vue';

export default {
  components: {
    UserMenu,
    IntroductionModal,
    MentorSidebarMenu,
    DashboardNotifications,
    DashboardMenteesList,
    MenteeRepsToReview,
    MenteeAssessmentLandingPage,
    MenteeAssessmentQuestionPage,
    AccountRepsToReview,
    MentorChecklist,
    EndUserLicenseAgreementModal,
    AskPanel,
    PlatformSummary,
  },
  data() {
    return {
      loading: false,
      accountName: '',
      menteeCount: '',
      previousYearMenteeCount: '',
      currentYearMenteeCount: '',
      repsReviewCount: '',
      previousWeekRepCount: '',
      currentWeekRepCount: '',
      competencyEarnedCount: '',
      previousWeekCompetencyCount: '',
      currentWeekCompetencyCount: '',
      isReptoReviewModalVisible: false,
      introduction_slide_obj: [],
      isIntroductionModalVisible: false,
      showSlideNumbers: false,
      isAssessmentLandingVisible: false,
      isAssessmentQuestionVisible: false,
      isAccountReptoReviewModalVisible: false,
      checklistCompleteFlag: 1,
      checklistLoading: false,
      menteeCountLoading: false,
      ticker: '',
      tickerText: '',
      isEndUserLicenseAgreementModalVisible: false,
      isAskModalVisible: false,
      role: 'mentor',
      aiSummaryFlag: 0,
    }
  },
  methods: {
    openAskModal() {
      this.isAskModalVisible = true;
      this.$refs.AskPanel.loadInitialData();
    },
    closeAskModal() {
      this.isAskModalVisible = false;
    },
    onSummaryAction(action) {
      const id = action && action.id ? action.id : '';
      if (id === 'open-reps-review') {
        this.openAccountRepToReviewModal();
      }
    },
    onAskAction(action) {
      const eventName = action && action.event ? action.event : '';
    },
    closeEndUserLicenseModal() {
      this.isEndUserLicenseAgreementModalVisible = false;
      this.getIntroductionTemplate();
    },
    openAccountRepToReviewModal() {
      this.isAccountReptoReviewModalVisible = true;
      this.$refs.AccountRepsToReview.getMenteeData();
    },
    closeAccountRepToReviewModal() {
      this.isAccountReptoReviewModalVisible = false;
    },
    competencyReport() {
      router.push("/competency-report");
    },
    goToAssessmentLanding(assessmentId, assessmentAttemptId) {
      this.$refs.MenteeAssessmentLandingModal.getLandingPageContent(assessmentId, assessmentAttemptId);
      this.isAssessmentLandingVisible = true;
    },
    closeAssessmentLandingModal() {
      this.isAssessmentLandingVisible = false;
    },
    openAssessmentQuestionModal(assessmentId, assessmentAttemptId) {
      this.$refs.MenteeAssessmentQuestionModal.getScaleLists(assessmentId, assessmentAttemptId);
      this.isAssessmentLandingVisible = false;
      this.isAssessmentQuestionVisible = true;
    },
    closeAssessmentQuestionModal () {
      this.isAssessmentQuestionVisible = false;
    },
    openRepToReviewModal(menteeId) {
      this.isReptoReviewModalVisible = true;
      this.$refs.MenteeRepsToReview.getMenteeData(menteeId);
    },
    closeRepToReviewModal() {
      this.isReptoReviewModalVisible = false;
    },
    reduceRepCount(data) {
      this.$refs.DashboardMenteesList.reduceRepCount(data);
    },
    showIntroductionSlide() {
      this.$refs.introduction_modal.getDefaultSlide();
      this.isIntroductionModalVisible = true;      
    },
    getAccountStatistics () {
      this.menteeCountLoading = true;
      axios.get('/desktop/v2/account-statistics', {
        params: {
          account_id: this.$store.state.user_accountid,
        }
      })
      .then(response =>  {
        this.menteeCountLoading = false;
        var licenseflag = response.data.eulaFlag;
        if(licenseflag == 0) {
          this.isEndUserLicenseAgreementModalVisible = true;
        }
        if(this.isEndUserLicenseAgreementModalVisible == false) {
          this.getIntroductionTemplate();
        }
        this.menteeCount = response.data.menteeCount;
        this.menteeNames = response.data.menteeNames;
        this.ticker = response.data.ticker;
        this.tickerText = response.data.text;
        this.repsReviewCount = response.data.repsReviewCount;
        this.previousWeekRepCount = response.data.previousWeekRepCount;
        this.currentWeekRepCount = response.data.currentWeekRepCount;
        this.competencyEarnedCount = response.data.competencyEarnedCount;
        this.previousWeekCompetencyCount = response.data.previousWeekCompetencyCount;
        this.currentWeekCompetencyCount = response.data.currentWeekCompetencyCount;
        this.checklistCompleteFlag = response.data.checklistCompleteFlag;

        if (this.checklistCompleteFlag == 0) {
          this.checklistLoading = false;
          setTimeout(() => {
            this.$refs.MentorChecklist.setUpData();
          }, 1000);
        }


      })
      .catch(function() {});
    },
    getIntroductionTemplate() {
      axios.get('/get-dashboard-introduction-slide', {
        params: {
          user_roles: 'ROLE_MENTOR',
          accountId: this.$store.state.user_accountid,
        }
      })
      .then(response =>  {
        this.introduction_slide_obj = response.data.introduction_slide;
        this.showSlideNumbers = response.data.showSlideNumbers;
        if(this.introduction_slide_obj.length > 0) {
        if(this.$store.state.introduction_template_display == 1) {
          setTimeout(() => {
          this.$refs.introduction_modal.getDefaultSlide();
          this.isIntroductionModalVisible = true;
          this.$store.dispatch('introduction_template_display', 0);
          }, 1000);
        }
        }
      })
      .catch(function() {});
    },
    
  },
  created() {
    this.menteeCountLoading = true;
    this.accountName = this.$store.state.user_locations.locations.find(loc => loc.accId === this.$store.state.user_accountid).accountName;

    axios.get('/get-account-ai-summary-flag', {
      params: {
        accountId: this.$store.state.user_accountid,
      }
    })
    .then(response =>  {
      this.aiSummaryFlag = response.data;
    })
    .catch(function() {});
    this.getAccountStatistics();
  },
}
</script>

<style scoped>
.information_box_title {
  font-size: 1.25rem !important;
}
@media (max-width: 1199.98px) {
  .information_box_title {
    font-size: 1rem !important;
  }
}
.content-wrapper {
  padding-top: 75px;
}
.container-wrapper .heading {
  font-size: 28px;
  font-weight: normal;
}
.information_box_text_up {
  border-radius: 5px;
  background-color: #D8F2FC;
}

.information_box_text_up i {
  color: #4DB1D8;
  transform: rotate(45deg);
}
.information_box_text_down {
  border-radius: 5px;
  background-color: #FBD9CC;

}
.information_box_text_down i {
  color: #F16733;
  transform: rotate(315deg);
}

@media (max-width: 1199.98px) {
  .information_box_text_up, .information_box_text_down {
    font-size: .65rem !important;
  }
}
input:focus, select:focus, textarea:focus, button:focus {
  border-color: #ced4da;
}
a {
  color: #00acee;
}
a:hover,
a:active,
a:focus {
  color: #00acee;
}
.stats_icon {
  width: 8px !important;
}
.fixed-bell-icon {
    position: fixed;
    right: 15px;
    bottom: 30px;
    border-radius: 50%;
    box-shadow: 1px 1px 11px 1px #a59a9a;
    font-size:25px;
    background-color: #29A3E4 !important;
    border-color: #29A3E4 !important; 
    cursor: pointer;
}
@media (max-width: 1366px) {
  .report-panel {
    width: 85px;
  }
}
@media (min-width: 1367px) {
  .report-panel {
    width: 112px;
  }
}
.mm-ask-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid #e4e9ec;
  background-color: rgba(0, 172, 238, 0.12);
  color: rgb(0, 144, 201);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  float: right;
}
.mm-ask-trigger:hover {
  background-color: rgba(0, 172, 238, 0.12);
  border: 1px solid #e4e9ec;
}
.mm-ask-trigger-icon {
  color: #00acee;
}
.mm-ask-trigger-label {
  white-space: nowrap;
}

</style>


// WEBPACK FOOTER //
// src/components/mentor/mentor_dashboard_v2.vue